export enum DonationRecurringOption {
  Once = 0,
  Recurring = 1,
  Pledge = 2,
}
